import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import { FooterStyled
        ,Sitemap 
       } from '../theme/globalStyle'
import { FormattedMessage } from 'react-intl'

const Footer = ({ siteTitle }) => (
    <FooterStyled>
        <Sitemap>
            <div>
                <h5><FormattedMessage id="footer-menu" /></h5>
                <Link to="/" ><FormattedMessage id="menu-home" /></Link>
                <Link to="/blog" ><FormattedMessage id="menu-blog" /></Link>
                <Link to="/category" ><FormattedMessage id="menu-category" /></Link>
                <Link to="/podcast" ><FormattedMessage id="menu-podcast" /></Link>
                <Link to="/social-networks/" ><FormattedMessage id="menu-social-network" /></Link>
                <Link to="/acknowledgments/" ><FormattedMessage id="acknowledgments" /></Link>
                <Link to="/about" ><FormattedMessage id="about" /></Link>
            </div>
            <div>
                <h5><FormattedMessage id="footer-languages" /></h5>
                <Link to='/es'><FormattedMessage id="es" /></Link>
                <Link to='/en'><FormattedMessage id="en" /></Link>
                <Link to='/pt'><FormattedMessage id="pt" /></Link>
            </div>
            <div>
                <h5><FormattedMessage id="menu-social-network" /></h5>
                <a href="https://medium.com/@yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to medium">Medium</a>
                <a href="https://www.facebook.com/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to facebook">Facebook</a>
                <a href="https://twitter.com/yhwhsalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to twitter">Twitter</a>
                <a href="https://yhwhesmisalvacion.tumblr.com/" target="_blank" rel="noopener noreferrer" aria-label="Go to tumblr">Tumblr</a>
                <a href="https://www.instagram.com/yhesmisalvacion/" target="_blank" rel="noopener noreferrer" aria-label="Go to Instragram">Instagram</a>
                <a href="https://www.youtube.com/channel/UC_P8nP2DLM5gQ7rUT3k4yZQ" target="_blank" rel="noopener noreferrer" aria-label="Go to Youtube">Youtube</a>
                <a href="https://www.pinterest.com/yhwhesmisalvacion/" target="_blank" rel="noopener noreferrer" aria-label="Go to pinterest">Pinterest</a>
            </div>
            <div>
                <h5><FormattedMessage id="footer-more" /></h5>
                <a href="https://www.reddit.com/user/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to reddit">Reddit</a>
                <a href="https://www.slideshare.net/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to SlideShare">SlideShare</a>
                <a href="https://t.me/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Telegram">Telegram</a>
                <a href="https://gitlab.com/yhwhesmisalvacion" target="_blank" rel="noopener noreferrer" aria-label="Go to Gitlab">Gitlab</a>
                <a href="https://archive.org/details/@yhwh_es_mi_salvaci_n" target="_blank" rel="noopener noreferrer" aria-label="Go to Archive">Archive</a>
            </div>
        </Sitemap>
    </FooterStyled>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: '',
}

export default Footer
